<template>
  <div>
    <general-table
      ref="generalTable"
      :api-url="apiUrl"
      :columns="columns"
      :type="type"
      :delete-content="false"
      :block-content="false"
      :edit-content="false"
      :view-content="false"
    >
      <template #cell(permissions)="data">
        <span class="font-weight-bold">
          {{ formatName(data.item.name) }}
        </span>
      </template>

      <template #cell(users)="data">
        <div
          class="d-flex flex-wrap align-items-center px-1"
          style="min-width: 150px"
        >
          <template v-if="Array.isArray(data.item.users) && data.item.users.length > 0">
            <!-- Show first 4 auditors -->
            <div
              v-for="(auditor, index) in data.item.users.slice(0, 4)"
              :key="auditor.id || index"
              :style="{ marginLeft: index !== 0 ? '-5px' : '0' }"
            >
              <span
                v-b-popover.hover.top.html="getSpan(auditor.name, auditor.email)"
              >
                <b-avatar
                  class="hover-avatar"
                  size="28"
                  :style="{
                    backgroundColor: colors[index % colors.length],
                    color: 'white',
                  }"
                  :text="getInitials(auditor.name)"
                />
              </span>
            </div>

            <!-- Show "+X" avatar if more than 4 auditors -->
            <div
              v-if="data.item.users.length > 4"
              :style="{ marginLeft: '-5px' }"
            >
              <span
                v-b-popover.hover.right.html="getRemainingAuditorsPopover(data.item.users.slice(4))"
              >
                <b-avatar
                  size="28"
                  variant="light-secondary"
                  class="font-weight-bold"
                >
                  +{{ data.item.users.length - 4 }}
                </b-avatar>
              </span>
            </div>
          </template>

          <!-- Fallback if auditors is not a valid array -->
          <template v-else>
            <span class="text-muted small">No users assigned</span>
          </template>

          <span
            v-b-popover.hover.right.html="'Add Users'"
            class="mx-1"
            @click="showSourceData(data.item.name)"
          >
            <b-avatar
              size="28"
              variant="dark"
              class="font-weight-bold cursor-pointer"
            >
              +
            </b-avatar>
          </span>
        </div>
      </template>

      <template #cell(roles)="data">
        <div
          class="d-flex flex-wrap align-items-center px-1"
        >
          <template v-if="data.item.roles.length > 0">
            <div
              v-for="(role, index) in data.item.roles"
              :key="index"
            >
              <b-badge
                :variant="colorsRole[index % colorsRole.length]"
                class="mr-1"
              >
                {{ role.name }}
              </b-badge>
            </div>
          </template>

          <!-- Fallback if auditors is not a valid array -->
          <template v-else>
            <span class="text-muted small">No roles assigned</span>
          </template>

          <span
            v-b-popover.hover.right.html="'Add Roles'"
            class="mx-1"
            @click="showRoleData(data.item.name)"
          >
            <b-avatar
              size="28"
              variant="dark"
              class="font-weight-bold cursor-pointer"
            >
              +
            </b-avatar>
          </span>
        </div>
      </template>

    </general-table>

    <b-modal
      v-model="isModalVisible"
      :title="'User Permissions'"
      size="lg"
      no-close-on-backdrop
      no-close-on-esc
      @hidden="renewGeneralData"
    >
      <template #modal-footer>
        <b-button
          variant="secondary"
          @click="isModalVisible = false"
        >
          Close
        </b-button>
      </template>
      <AddDeleteUserTable
        :source-data="permissionName"
      />
    </b-modal>

    <b-modal
      v-model="isRolesModalVisible"
      :title="'Roles'"
      hide-footer
      size="lg"
      @hidden="renewGeneralData"
    >
      <AddDeleteRoleTable
        :source-data="roleName"
      />
    </b-modal>
  </div>
</template>

<script>
import GeneralTable from '@/components/general-table/GeneralTable.vue'
import AddDeleteUserTable from './control-permission/AddDeleteUserTable.vue'
import AddDeleteRoleTable from './control-permission/AddDeleteRoleTable.vue'

export default {
  components: { GeneralTable, AddDeleteUserTable, AddDeleteRoleTable },
  data() {
    return {
      APIURL: 'permissions',
      type: 'page',
      partners: [],
      filter: {},
      types: '',
      columns: [
        { key: 'permissions', label: 'Permissions' },
        { key: 'roles', label: 'Roles' },
        { key: 'users', label: 'Users' },
      ],
      colors: [
        '#FF5733', // red-orange
        '#33B5FF', // blue
        '#28A745', // green
        '#FFC107', // amber
        '#6F42C1', // purple
        '#E83E8C', // pink
        '#20C997', // teal
        '#FD7E14', // orange
      ],
      colorsRole: [
        'primary',
        'secondary',
        'danger',
        'warning',
        'info',
      ],
      isModalVisible: false,
      isRolesModalVisible: false,
      permissionName: '',
      roleName: '',
    }
  },

  computed: {
    apiUrl() {
      let base = 'permissions?'

      if (!Object.values(this.filter).length) {
        return base.slice(0, -1)
      }

      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(this.filter)) {
        if (key && value) {
          base += `${key}=${value}&`
        }
      }
      // console.log(base.slice(0, -1))
      return base.slice(0, -1)
    },
  },
  // mounted() {
  //   console.log('Count in mounted:', this.role)
  // },

  methods: {
    formatName(name) {
      if (!name) return ''
      return name
        .replace(/_/g, ' ')
        .toUpperCase()
    },
    renewGeneralData() {
      this.$refs.generalTable.getAllData()
    },
    /** ***********  ✨ Windsurf Command ⭐  ************ */
    /**
     * Shows the modal for permission source data
     * @param {String} data - The permission name
     */
    /** *****  dc269ad9-7448-4457-9dd1-fbc53da154c5  ****** */
    showSourceData(data) {
      this.isModalVisible = true
      this.permissionName = data
    },
    showRoleData(data) {
      this.isRolesModalVisible = true
      this.roleName = data
    },
    getInitials(fullName) {
      if (!fullName) return ''
      const str = String(fullName).trim()
      if (!str) return ''
      const parts = str.split(/\s+/)
      if (parts.length === 1) {
        return parts[0][0]?.toUpperCase() || ''
      }
      return (parts[0][0] + parts[1][0]).toUpperCase()
    },
    getSpan(name, email) {
      return `<div style="text-align: start; color: black">${name}</div>
    <div style="text-align: start; color: gray">${email}</div>`
    },
    getRemainingAuditorsPopover(auditors) {
    // Build HTML popover with all remaining auditors
      return auditors
        .map(
          auditor => `
        <div style="text-align:start; margin-bottom:4px;">
          <div style="color:black; font-weight:500;">${auditor.name}</div>
          <div style="color:gray;">${auditor.email}</div>
        </div>
      `,
        )
        .join('')
    },
  },
}
</script>
